import React, { Component } from 'react';
import { connect } from 'react-redux';
import Sidebar from 'react-sidebar';
import {toggleSiderBarOpen} from '../../actions/authActions';
import SideBarContent from './sideBarContent';

class SidebarComponent extends Component {

    onSetSidebarOpen(open) {
        this.props.toggleSiderBarOpen(!this.props.sideBarOpen)
    }

    render() {
        return (
            <Sidebar
                sidebar={<SideBarContent/>}
                open={this.props.sideBarOpen}
                onSetOpen={this.onSetSidebarOpen.bind(this)}
                styles={{ sidebar: { background: "white", marginTop: 50 } }}
            >
                <div></div>
            </Sidebar>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        sideBarOpen: state.auth.sideBarOpen,
    }
}

export default connect(mapStateToProps, { toggleSiderBarOpen })(SidebarComponent);


// WEBPACK FOOTER //
// ./src/v3/components/createCampaign/sideBarComponent.js